import React from 'react';
import PropTypes from 'prop-types';

import CCSSelect from '@ey/canvascoreservices/Select';

const Select = ({...rest}) => <CCSSelect {...rest} />;

Select.propTypes = {};

export default Select;
